import axios from 'axios'

import { getAPIConfig } from '@/utils/apiConfig'

const apiInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
})

apiInstance.interceptors.request.use(
  async (config) => {
    const apiConfig = await getAPIConfig()

    config.baseURL = apiConfig.auth

    return config
  },
  (error) => {
    // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
    return Promise.reject(error)
  },
)

apiInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/prefer-promise-reject-errors
    return error?.response?.data ? Promise.reject(error?.response?.data) : Promise.reject(error)
  },
)

export default apiInstance
